import { useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ExpertDataService from "../../services/Expert";

import { SingleProgrammeList } from "../../components/List/SingleProgrammeList";
import CorporateBannerModal from "../../components/Modals/CorporateBannerModal";
export const ProgrammeExpertList = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const [list, setList] = useState<any>();
  const [modal, setModal] = useState<any>("");
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const fetchData = async () => {
    ExpertDataService.getProgrammeExperts(token)
      .then((res: any) => {
        setList(res.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Fuji Experts</div>

        <div className="p-4">
          <div className="top_section_container">
            <div className="expert_container_item expert_list_button ">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("informationbanner");
                    onOpen();
                  }}
                >
                  Add Information
                </button>
              </div>
              {modal === "informationbanner" && (
                <CorporateBannerModal isOpen={isOpen} onClose={onClose} />
              )}
            </div>
          </div>

          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  {/* <th>Edit</th> */}
                  <th>Expert Name</th>
                  <th>Location</th>
                  <th>Add Attendance</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleProgrammeList
                      key={el.id}
                      props={el.data}
                      id={el._id}
                      func={fetchData}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
